import { __decorate } from "tslib";
import { Component, EventEmitter, Input, Output, ViewEncapsulation } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { WebsiteThemeService } from '../../services/website-theme.service';
import { Router } from "@angular/router";
import { ComponentService } from "../../services/component.service";
import { LocationStrategy } from "@angular/common";
import { SharedHttp } from "../../services/http-client.service";
import { AuthService } from "../../services/auth.service";
export let browserRefresh = false;
/**
 * Session Expiration Component
 */
let SessionExpirationComponent = class SessionExpirationComponent {
    constructor(sanitizer, router, compService, location, httpClient, themeService, auth) {
        this.sanitizer = sanitizer;
        this.router = router;
        this.compService = compService;
        this.location = location;
        this.httpClient = httpClient;
        this.themeService = themeService;
        this.auth = auth;
        this.borderRadiusSmaller = '';
        this.borderRadiusLarger = '';
        this.extendButtonClicked = false;
        this.startedTimer = Date.now();
        this.logoutUser = new EventEmitter();
        this.extendUserSession = new EventEmitter();
        this.themeService.getTheme().subscribe((data) => {
            this.borderRadiusSmaller = this.themeService.getStyleAttribute('border_radius_smaller');
            this.borderRadiusLarger = this.themeService.getStyleAttribute('border_radius_larger');
        });
        location.onPopState(() => {
            this.close();
        });
    }
    ngOnInit() {
    }
    ngOnDestroy() {
        if (this.intervalId) {
            clearInterval(this.intervalId);
        }
    }
    close() {
        this.modal.destroy();
    }
    extendSession() {
        this.extendUserSession.emit();
    }
    logout() {
        this.logoutUser.emit();
    }
};
SessionExpirationComponent.ctorParameters = () => [
    { type: DomSanitizer },
    { type: Router },
    { type: ComponentService },
    { type: LocationStrategy },
    { type: SharedHttp },
    { type: WebsiteThemeService },
    { type: AuthService }
];
__decorate([
    Input()
], SessionExpirationComponent.prototype, "countdown", void 0);
__decorate([
    Output()
], SessionExpirationComponent.prototype, "logoutUser", void 0);
__decorate([
    Output()
], SessionExpirationComponent.prototype, "extendUserSession", void 0);
SessionExpirationComponent = __decorate([
    Component({
        selector: 'ecd-session-expiration',
        encapsulation: ViewEncapsulation.None,
        template: __importDefault(require("./session-expiration.component.html")).default
    })
], SessionExpirationComponent);
export { SessionExpirationComponent };
